export const environment = {
    production: false,
    debug: true,
};

export const API_CONFIG = {
    host: "http://localhost:3000",
}

export const EXPERIMENT_RUNS_CONFIG = {
    api: {
        run: '/experiment-runs/run',
        status: '/experiment-runs/:id/status'
    }
}